var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
require('bootstrap/transition');
require('bootstrap/carousel');
var Hammer = require('hammerjs');
var ImageBlur = require('../../src/js/lib/image-blur.js');

function MediaGallery(el) {
	this.el = el;
	this.$el = $(el);
	this.$carousel = this.$el.find('.carousel');
	this.$items = this.$carousel.find('.item');

	this.$items.not('.active').attr('aria-hidden', 'true')

	$(window).on('resize', this.onResize.bind(this));
	this.onResize();

	var $images = this.$el.find('.media-gallery__slide img');
	var $backgrounds = this.$el.find('.media-gallery__bg');

	$backgrounds.each(function(index, el) {
		var url = $(el).attr('data-blur-bg');

		new ImageBlur({
			el: el,
			path: url,
			radius: 50
		});
	});

	this.$carousel.on('slide.bs.carousel', this.onSlideStart.bind(this));
	this.$carousel.on('slid.bs.carousel', this.onSlideFinish.bind(this));

	this.$carousel.on('click', '.item.active + .item', function() {
		this.$carousel.carousel('next');
	}.bind(this));

	var galleryTouch = new Hammer(this.el);

	galleryTouch.on('swipe', function(event) {
		console.log(event);
		if(event.direction === 2) {
			this.$carousel.carousel('next');
		} else if(event.direction === 4) {
			this.$carousel.carousel('prev');
		}
	}.bind(this));
}

MediaGallery.prototype = {
	onSlideStart: function(event) {
		this.$carousel.addClass('sliding');
		var $active = this.$items.filter('.active');
		var $next = (event.direction === 'left') ? $active.next() : $active.prev();
		var $beforeNext = $next.prev();

		$beforeNext.addClass('before-active');
		this.$items.not($beforeNext).removeClass('before-active');

		var index = $next.index();

		this.$items.attr('aria-hidden', 'true')
		$next.removeAttr('aria-hidden')

		this.$el.find('.media-gallery__slide-index').text(index+1);
		this.$el.find('.media-gallery__bg').eq(index).addClass('active').siblings().removeClass('active');

		if(index === 0) {
			$('.media-gallery__control').first().addClass('disabled').attr('tabindex', '-1')
				.siblings().removeClass('disabled').removeAttr('tabindex');
		} else if(index === this.$carousel.find('.item').length - 1) {
			$('.media-gallery__control').last().addClass('disabled').attr('tabindex', '-1')
				.siblings().removeClass('disabled').removeAttr('tabindex');
		} else {
			$('.media-gallery__control').removeClass('disabled').removeAttr('tabindex');
		}

		requestAnimationFrame(function() {
			this.sizeToSlide($next);
		}.bind(this));
	},
	onSlideFinish: function(event) {
		this.$carousel.removeClass('sliding');
		// this.onResize();
	},
	onResize: function(event) {
		var $active = this.$carousel.find('.item.active');
		this.sizeToSlide($active);
	},
	sizeToSlide: function($slide) {
		var $inner = this.$carousel.find('.carousel-inner');
		var $title = this.$el.find('.media-gallery__title');

		$inner.css('height', $slide.height());

		if(window.innerWidth >= 850) {
			var $slideMedia = $slide.find('.media-gallery__slide-media');
			$title.css('height', $slideMedia.outerHeight());
		}
	}
}

module.exports = MediaGallery;
